var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstrumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instrument-Automata-icon@2x-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 12V18.5H29V12H19.5C19.2239 12 19 11.7761 19 11.5C19 11.2239 19.2239 11 19.5 11H29.5C29.7761 11 30 11.2239 30 11.5V19C30 19.2761 29.7761 19.5 29.5 19.5H16.5C16.2239 19.5 16 19.2761 16 19V11.5C16 11.2239 16.2239 11 16.5 11H18C18.2761 11 18.5 11.2239 18.5 11.5C18.5 11.7761 18.2761 12 18 12H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 8.5H13.5C13.2239 8.5 13 8.72386 13 9V21.5C13 21.7761 13.2239 22 13.5 22H32.5C32.7761 22 33 21.7761 33 21.5V9C33 8.72386 32.7761 8.5 32.5 8.5ZM14 21V9.5H32V21H14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16C9 13.9497 10.2341 12.1876 12 11.416V13.1273C11.0933 13.7598 10.5 14.8106 10.5 16V23.5C10.5 24.952 10.6812 25.5875 11.0958 25.9343C11.3101 26.1136 11.6344 26.2567 12.1561 26.351C12.6786 26.4454 13.3585 26.4839 14.25 26.4839H19.5L21.5 26.4954C23.2866 26.5803 24.3862 27.1285 25.0221 27.9592C25.6946 28.8378 25.75 29.9166 25.75 30.6855V37H28.5C28.7761 37 29 37.2239 29 37.5V42.5H37.5V16C37.5 14.067 35.933 12.5 34 12.5V11C36.7614 11 39 13.2386 39 16V43.5C39 43.7761 38.7761 44 38.5 44H9.5C9.22385 44 9 43.7761 9 43.5V16ZM10.5 42.5V26.7386C10.8915 27.0488 11.3889 27.2285 11.9783 27.335C12.5902 27.4455 13.3415 27.4839 14.25 27.4839H21.009C22.9181 27.4855 23.7968 28.0037 24.2279 28.567C24.6804 29.1581 24.75 29.9301 24.75 30.6855V37H22V36C22 35.7239 21.7761 35.5 21.5 35.5H14C13.7239 35.5 13.5 35.7239 13.5 36V37H12C11.7239 37 11.5 37.2239 11.5 37.5V42.5H10.5ZM12.5 38V42.5H28V38H12.5ZM21 37V36.5H14.5V37H21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrumentIcon);
export default __webpack_public_path__ + "static/media/instrument-icon.00022e05616794bb8f913fa53c6b1a64.svg";
export { ForwardRef as ReactComponent };